// extracted by mini-css-extract-plugin
export default {"wrapper":"uKr3Jn","ols_vets":"zykhIk","olsVets":"zykhIk","container":"jdxHYl","itemsWrapper":"dZL9tt","itemsContainer":"UvB2Ly","item":"fdQ_8K","icon":"aDVFfE"};